import * as viewModels from '../../view/view-models';
import * as models from '../../domain/models';
import * as actions from '../actions/aircraft-collection';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  items: Array<models.Aircraft>;
  selectedItems: Array<models.Aircraft>;
  lookup: viewModels.AircraftLookup;
  isImportStatusLoaded: boolean;
  isImportStatusLoading: boolean;
  importStatus: boolean;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  items: [],
  selectedItems: [],
  lookup: new viewModels.AircraftLookup(),
  isImportStatusLoaded: false,
  isImportStatusLoading: false,
  importStatus: null,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        lookup: _.cloneDeep(action.payload.lookup),
        isLoading: true,
      };
    }

    // case actions.SAVE_SUCCESS:
    case actions.LOAD_SUCCESS: {
      const items = _.cloneDeep(action.payload.items);
      const lookup = _.cloneDeep(state.lookup);
      lookup.total = action.payload.total;
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        lookup,
        items,
      };
    }

    case actions.LOAD_FAIL: {
      const lookup = _.cloneDeep(state.lookup);
      return {
        ...initialState,
        isLoaded: true,
        lookup,
      };
    }

    case actions.RESET: {
      return {
        ...initialState,
      }
    }

    case actions.SET_SELECTED_AIRCRAFT: {
      const selectedItems = _.cloneDeep(action.payload);
      return {
        ...state,
        selectedItems
      };
    }

    case actions.BULK_SAVE_AIRCRAFTS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case actions.BULK_SAVE_AIRCRAFTS_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        selectedItems: []
      };
    }

    case actions.BULK_SAVE_AIRCRAFTS_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.GET_IMPORT_STATUS: {
      return {
        ...state,
        isImportStatusLoading: true
      }
    }

    case actions.GET_IMPORT_STATUS_SUCCESS: {
      return {
        ...state,
        isImportStatusLoading: false,
        isImportStatusLoaded: true,
        importStatus: action.payload
      }
    }

    case actions.GET_IMPORT_STATUS_FAIL: {
      return {
        ...state,
        isImportStatusLoading: false,
        isImportStatusLoaded: true,
        importStatus: true
      }
    }

    case actions.RESET_IMPORT_STATUS_STATE: {
      return {
        ...state,
        isImportStatusLoaded: false,
        isImportStatusLoading: false,
        importStatus: null
      }
    }

    case actions.AIRCRAFT_PRICING_BULK_UPDATE_SUCCESS: {
      return {
        ...state,
        selectedItems: []
      }
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItems = (state: State) => state.items;
export const getSelectedItems = (state: State) => state.selectedItems;
export const getLookup = (state: State) => state.lookup;
export const getImportStatusIsLoading = (state: State) => state.isImportStatusLoading;
export const getImportStatusIsLoaded = (state: State) => state.isImportStatusLoaded;
export const getImportStatus = (state: State) => state.importStatus;
